import * as Sentry from '@sentry/react';

import { QUESTION_IDS, type QUESTION_IDS_TYPE } from 'bundles/onboarding-common/constants/questionScheme';

import _t from 'i18n!nls/onboarding-common';

const mapQuestionPathToQuestionIdList = (questionPath: string[]): QUESTION_IDS_TYPE[] => {
  return questionPath.reduce<QUESTION_IDS_TYPE[]>((acc, question) => {
    switch (question) {
      case 'LEARNING_GOAL':
        return [...acc, QUESTION_IDS.learningGoal];
      case 'ROLE':
        return [...acc, QUESTION_IDS.roleSelect];
      case 'SKILL':
        return [...acc, QUESTION_IDS.skillSelect];
      case 'JOB_TITLE':
        return [...acc, QUESTION_IDS.jobTitle];
      case 'EDUCATION_LEVEL':
        return [...acc, QUESTION_IDS.educationLevel];
      default:
        Sentry.captureMessage(`Unknown question ID: ${question}`);
        return acc;
    }
  }, []);
};

const getQuestionTitleAndSupportingText = (
  questionId: QUESTION_IDS_TYPE,
  { isAdvancer = false, isPopularSkills = false }: { isAdvancer?: boolean; isPopularSkills?: boolean }
) => {
  switch (questionId) {
    case QUESTION_IDS.learningGoal:
      return {
        title: _t('Select your goal to personalize your recommendations'),
      };
    case QUESTION_IDS.roleSelect:
      return isAdvancer
        ? {
            title: _t('What is your current role?'),
          }
        : {
            title: _t('Which role(s) are you interested in?'),
          };
    case QUESTION_IDS.skillSelect:
      return {
        title: _t("Select the skills you'd like to develop"),
        supportingText: isPopularSkills
          ? _t('These are some of our most popular skills')
          : _t('These are recommended based on your role(s)'),
      };
    default:
      return {
        title: '',
        supportingText: '',
      };
  }
};

export { getQuestionTitleAndSupportingText, mapQuestionPathToQuestionIdList };
